export default __webpack_public_path__ + "static/media/logoCirculo.a478d99c.png";